export default () => ({
  primary: { lineHeight: 1.3 },
  secondary: {
    lineHeight: 1.3,
    fontSize: '12px',
  },
  root: {
    padding: '0 8px',
    marginTop: 0,
  },
  miniAvatar: {
    display: 'inline-block',
    height: 32,
    width: 32,
  },
  miniImg: { verticalAlign: 'top' },
  bordered: { border: '2px solid white' },
  listItem: {
    padding: 0,
    alignItems: 'flex-start',
  },
  avatar: {
    width: 33,
    height: 33,
  },
});
